import type { IconElement } from '@backstage/frontend-plugin-api';
import { OdooIcon } from './brandIcons';
import { OdooShellIcon } from './terminalIcons';
import { OdooInstanceIcon } from './webIcons';

// Les entrées propres à Odoo du registre d'icônes de l'application
// (modules/icons.tsx), séparées de `components/ui/icons/iconBundle.tsx` à
// l'étape 9c du plan « plateforme d'applications » pour rejoindre le module
// Odoo (étape 9e). Mêmes règles : des éléments, décoratifs.
export const odooIconBundle: Readonly<Record<string, IconElement>> = {
  // The Odoo shell's own button: in colour, 1em and aria-hidden of its own
  // (terminalIcons.tsx), like the pod's terminal.
  'odoo-shell': <OdooShellIcon />,
  // The way into an environment's Odoo instance (its ingress), in
  // colour too (webIcons.tsx). Not `login`, signing in to Backstage.
  'odoo-instance': <OdooInstanceIcon />,
  // The Odoo version badge (OdooVersionBadge.tsx).
  odoo: <OdooIcon fontSize="inherit" />,
};
